import React, { useState } from "react";
import api from "../../../api/api";
import Swal from "sweetalert2";

import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const ShippingTrip = () => {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    vessel_name: "",
  });

  // =========================================
  // HANDLE CHANGE
  // =========================================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // =========================================
  // HANDLE SUBMIT
  // =========================================
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await api.post("/shipping-trips/", form);

      Swal.fire({
        icon: "success",
        title: "Trip Created",
        text: "Shipping trip created successfully.",
        confirmButtonColor: "#f59e0b",
      });

      // RESET
      setForm({
        name: "",
        vessel_name: "",
      });

    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create shipping trip.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: 5,
          overflow: "hidden",
          border: "1px solid #e5e7eb",
          background: "#fff",
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)",

            color: "#fff",

            p: 4,
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <LocalShippingIcon sx={{ fontSize: 34 }} />
            Assign Shipping Trip
          </Typography>

          <Typography
            sx={{
              mt: 1,
              opacity: 0.85,
            }}
          >
            Create and manage shipment vessel trips.
          </Typography>
        </Box>

        {/* FORM */}
        <Box
          sx={{
            p: {
              xs: 2,
              md: 4,
            },
          }}
        >
          <form onSubmit={handleSubmit}>

            {/* TRIP NAME */}
            <TextField
              fullWidth
              required
              label="Trip Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              sx={{ mb: 3 }}
            />

            {/* VESSEL NAME */}
            <TextField
              fullWidth
              required
              label="Vessel Name"
              name="vessel_name"
              value={form.vessel_name}
              onChange={handleChange}
              sx={{ mb: 4 }}
            />

            {/* SUBMIT BUTTON */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                py: 1.6,
                borderRadius: 3,

                fontWeight: "bold",

                fontSize: "1rem",

                textTransform: "none",

                background:
                  "linear-gradient(90deg, #f59e0b, #ea580c)",

                boxShadow: "none",

                "&:hover": {
                  background:
                    "linear-gradient(90deg, #d97706, #c2410c)",
                },
              }}
            >
              {loading ? (
                <CircularProgress
                  size={24}
                  sx={{ color: "#fff" }}
                />
              ) : (
                "Create Shipping Trip"
              )}
            </Button>

          </form>
        </Box>
      </Paper>
    </Box>
  );
};

export default ShippingTrip;


// import React, { useState } from "react";
// import api from "../../../api/api";
// import Swal from "sweetalert2";

// import {
//   Box,
//   Paper,
//   TextField,
//   Button,
//   Typography,
//   CircularProgress,
// } from "@mui/material";

// const ShippingTrip = () => {
//   const [loading, setLoading] = useState(false);

//   const [form, setForm] = useState({
//     name: "",
//     vessel_name: "",
//   });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       await api.post("/shipping-trips/", form);

//       Swal.fire({
//         icon: "success",
//         title: "Trip Created",
//         text: "Shipping trip has been created successfully.",
//         confirmButtonColor: "#ff6a00",
//       });

//       setForm({ name: "", vessel_name: "" });

//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to create trip.",
//       });
//     }

//     setLoading(false);
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         background: "#f4f6f8",
//         p: 2,
//       }}
//     >
//       <Paper
//         sx={{
//           width: "100%",
//           maxWidth: 600,
//           p: 4,
//           borderRadius: 3,
//         }}
//       >
//         <Typography variant="h5" fontWeight="bold" mb={3}>
//           Create Shipping Trip
//         </Typography>

//         <form onSubmit={handleSubmit}>
//           <TextField
//             fullWidth
//             label="Trip Name"
//             name="name"
//             value={form.name}
//             onChange={handleChange}
//             sx={{ mb: 2 }}
//           />

//           <TextField
//             fullWidth
//             label="Vessel Name"
//             name="vessel_name"
//             value={form.vessel_name}
//             onChange={handleChange}
//             sx={{ mb: 3 }}
//           />

//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             disabled={loading}
//             sx={{
//               background: "linear-gradient(90deg, #ffb400, #ff6a00)",
//               color: "#000",
//               fontWeight: "bold",
//               py: 1.5,
//             }}
//           >
//             {loading ? <CircularProgress size={24} /> : "Create Trip"}
//           </Button>
//         </form>
//       </Paper>
//     </Box>
//   );
// };

// export default ShippingTrip;